import { render, staticRenderFns } from "./Other.vue?vue&type=template&id=4bad660e&"
import script from "./Other.vue?vue&type=script&lang=ts&"
export * from "./Other.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports